import script from "./DefaultLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultLayout.vue?vue&type=script&setup=true&lang=ts"

import "./DefaultLayout.vue?vue&type=style&index=0&id=24b324e5&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b324e5"]])

export default __exports__